import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xeHFxMW05MCB7CiAgcG9zaXRpb246IGFic29sdXRlOwogIGluc2V0OiAwOwp9';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xeHFxMW05MSB7CiAgaGVpZ2h0OiAxMDAlOwp9';
export var styledWrapperClass = '_1xqq1m90';
export var centerViewportClass = '_1xqq1m91';